// Header scroll behavior - Make header compact when scrolling
document.addEventListener('DOMContentLoaded', function() {
  const headerWrapper = document.querySelector('.header-wrapper');
  
  if (!headerWrapper) return;
  
  let lastScrollTop = 0;
  const scrollThreshold = 100; // Start compacting after 100px scroll
  
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > scrollThreshold) {
      headerWrapper.classList.add('scrolled');
    } else {
      headerWrapper.classList.remove('scrolled');
    }
    
    lastScrollTop = scrollTop;
  }
  
  // Add scroll event listener
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Initial check
  handleScroll();
});
